"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResolvedConfig = void 0;
var tslib_1 = require("tslib");
var keys_1 = tslib_1.__importDefault(require("lodash/keys"));
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var RequiredConfigKeys = [
    "dateFilterConfig",
    "locale",
    "separators",
    "colorPalette",
    "settings",
];
/**
 * Tests whether the provided config is fully resolved - it contains all the necessary values.
 *
 * @param config - config to test
 */
function isResolvedConfig(config) {
    if (!config) {
        return false;
    }
    var specifiedConfig = keys_1.default(config);
    return RequiredConfigKeys.every(function (key) { return includes_1.default(specifiedConfig, key); });
}
exports.isResolvedConfig = isResolvedConfig;
//# sourceMappingURL=commonTypes.js.map